import Store from '@/store/store'
import {getUserInfo} from '@/api/user.js'

Store.registerModule('menu', {
    namespaced: true,
    state: {
        menu: [],
        tabs: [],
		activeItem: '11',//当前一级菜单
		activeSubItem: '',//当前二级菜单
        token: '',
        id: '',      //登录用户id
        fromPage: '',     // 
        fromPageIccid: '',    //用于跳转至【卡片详情】的iccid
        iccidToAccount: '',    //用于跳转至【账户余额】的iccid
        fromPageOrderNo: '',//用于跳转至【账户充值订单】的单号
        toOrderMgtOrderNo: '',//用于跳转至【卡片详情】的单号
        nickName:'',
        payGateWay: '',//支付宝二维码
        btns:'',
        fluxPollDetailTaskNo: '',//用于跳转至【流量轮询详情】的任务编号
        fluxPollDetailIccid: '',//用于跳转至【流量轮询详情】的iccid
        isFluxPollDetailTab:false,
        isPersonalCenterTab:false,

    },
    getters: {
        subMenu(state) {
            var subs = state.menu.filter(f => f.sub).map(f => f.sub);
            function jsonUniq(arrjson, key) {
                    let arr1 = [arrjson[0]];
                    arrjson.forEach(function (item1, idx1) {
                        let flag = false;
                        arr1.forEach(function (item2, idx2) {
                            if (item1[key] == item2[key]) {
                                flag = true;
                                return;
                            }
                        })
                        if (!flag ) {
                            arr1.push(item1)
                        }
                    })
                    return arr1;
            }
            if(subs && subs.length > 0){
                return jsonUniq(subs,'id');
            }else{
                return [];
            }
        },
        itemMenu(state) {
            return (pid, group) => {
                var items = state.menu
                    .filter(f => f.pid == pid)
                    .map(f => {
                        return {
                            name: f.name,
                            index: f.index,
                            path: f.path
                        }
                    });                   
                return Array.from(new Set(items))
            }
        },
        getNickName: state => state.nickName,
        hasAuthority(state){       
            return (code) => {
                if(state.btns){
                    return  state.btns.indexOf(code)!=-1
                }else{
                    return false;
                }
            }
        }
    },
    mutations: {
        initMenu(state, menu) {
            state.menu = menu;
        },
        initTabs(state, tabs) {
            state.tabs = tabs;
        },
        addTab(state, tab) {
            state.tabs.push(tab)
        },
        switchTab(state, nowIndex) {
            state.activeSubItem = nowIndex
        },
		setActiveItem(state, activeItem){
			state.activeItem = activeItem;
		},
        setNickName(state,nickName){
            state.nickName = nickName;
        },
        setFromPage(state, fromPage){
            state.fromPage = fromPage;
        },
        setIccidToAccount(state, iccid){
            state.iccidToAccount = iccid;
        },
        setFromPageIccid(state, iccid){
            state.fromPageIccid = iccid;
        },
        setFromPageOrderNo(state, orderNo){
            state.fromPageOrderNo = orderNo;
        },
        setToOrderMgtOrderNo(state, orderNo){
            state.toOrderMgtOrderNo = orderNo;
        },
        setToken(state, token){
            state.token = token;
        },
        setId(state, id){
            state.id = id
        },
        setBtns(state,btns){
            state.btns = btns;
        },
        setFluxPollDetailTaskNo(state,fluxPollDetailTaskNo){
            state.fluxPollDetailTaskNo = fluxPollDetailTaskNo;
        },
        setFluxPollDetailIccid(state,fluxPollDetailIccid){
            state.fluxPollDetailIccid = fluxPollDetailIccid;
        },
        setIsFluxPollDetailTab(state,isFluxPollDetailTab){
            state.isFluxPollDetailTab = isFluxPollDetailTab;
        },
        setIsPersonalCenterTab(state,isPersonalCenterTab){
            state.isPersonalCenterTab = isPersonalCenterTab;
        },
    },
    actions: {
        setBtns(context,btns){
            context.commit('setBtns', btns);
        },
        setNickName(context,nickName){
            context.commit('setNickName', nickName);
        },
        getMenu(context) {
            var data = {
                id: localStorage.getItem('id')
            }
            getUserInfo(data).then(rsp=>{
                let menus = [];
                if(rsp.data){
                    sessionStorage.setItem("isCollect",rsp.data.data.isCollect);
                    rsp.data.data.loginSysMenuVoList.forEach(item => {
                        if(item.nextLoginMenuVoList && item.nextLoginMenuVoList.length > 0){
                            item.nextLoginMenuVoList.forEach(item2=>{
                                if(rsp.data.data.isCollect == 1 && (item2.path=='finance/myAccounting' ||
                                    item2.path=='finance/orderSettlement')){
                                }else{
                                    menus.push({
                                        name:item2.name,
                                        sub:{'name':item.name,'icon':item.icon,'id':item.id},
                                        index:item2.id,
                                        id:item2.id,
                                        pid:item2.pid,
                                        path: item2.path,
                                        componentPath: 'views/'+ item2.path
                                    });
                                }
                                
                            });
                        }
                    });
                    context.commit('initMenu', menus);
                    context.commit('setBtns', rsp.data.data.actionCodes);
                }
            }).catch(err=>{
                // debugger
                location.href = "/";
            });
        },
        clickMenuItem(context, index) {
			if (index != "adminIndex") {
				//若当前tab组没有与菜单对应的tab，则新增
				var tab = context.state.tabs.find(f => f.index == index)
				if (!tab) {
					let menu = context.state.menu.find(f => f.index == index)
					let component =import(`@/${menu.componentPath ? menu.componentPath : 'components/NotFound.vue'}`)
					var newTab = {
						label: menu.name,
						index: menu.index,
						closable: true,
						component:menu.componentPath
					}

					context.commit('addTab', newTab)
				}
			}
			context.commit('switchTab', index)

			//更新当前一级菜单记录
			let menu = context.state.menu.find(f => f.index == context.state.activeSubItem)
			context.commit('setActiveItem', menu.sub.id);
		},
		closeTab(context, index) {
            if(index=="personalCenter"){
                context.commit('setIsPersonalCenterTab', false);
            }

            if( index=="fluxPollDetail"){
                context.commit('setIsFluxPollDetailTab', false);
            }

			let indexNum = context.state.tabs.findIndex(f => f.index == index);
			let newTabs = context.state.tabs.filter(f => f.index != index);
			context.commit('initTabs', newTabs)
			if (context.state.activeSubItem == index) {
				context.commit('switchTab', indexNum == 0 ? "adminIndex" : newTabs[indexNum - 1].index)
			}

			//更新当前一级菜单记录
			let menu = context.state.menu.find(f => f.index == context.state.activeSubItem)
			context.commit('setActiveItem', menu.sub.id);

		},

		switchTab(context, nowIndex) {
			context.commit('switchTab', nowIndex)

            if(nowIndex!="personalCenter" && nowIndex!="fluxPollDetail"){
                //更新当前一级菜单记录
                let menu = context.state.menu.find(f => f.index == context.state.activeSubItem)
                context.commit('setActiveItem', menu.sub.id);
            }

			
		},

    }
})